import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function CurriculumPopup() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const hasShown = sessionStorage.getItem('2n_popup_shown');
    if (!hasShown) {
      const timer = setTimeout(() => {
        setIsVisible(true);
        sessionStorage.setItem('2n_popup_shown', 'true');
      }, 30000); // 30 seconds
      return () => clearTimeout(timer);
    }
  }, []);
  if (!isVisible) return null;
  return <div className="fixed inset-0 z-[120] flex items-center justify-center p-4 sm:p-6" data-id="element-214">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm animate-fadeIn" onClick={() => setIsVisible(false)} data-id="element-215" />

      {/* Modal */}
      <div className="relative w-full max-w-2xl bg-[#1a1a1a] rounded-2xl shadow-2xl overflow-hidden animate-scaleIn flex flex-col" onClick={e => e.stopPropagation()} data-id="element-216">
        <button onClick={() => setIsVisible(false)} className="absolute top-4 right-4 z-10 bg-black/50 hover:bg-black/80 text-white p-2 rounded-full backdrop-blur-md transition-colors" data-id="element-217">
          <XIcon className="w-5 h-5" data-id="element-218" />
        </button>

        {/* Header Image */}
        <div className="relative w-full aspect-[21/9] sm:aspect-[21/8]" data-id="element-219">
          <img src="https://cdn.rawproductionsgmbh.de/2n/home/curriculum.jpeg" alt="Curriculum" className="w-full h-full object-cover" data-id="element-220" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a] to-transparent" data-id="element-221" />
        </div>

        {/* Content */}
        <div className="px-6 sm:px-8 pb-8 sm:pb-10 pt-2 text-center relative z-10" data-id="element-222">
          <h2 className="text-white font-extrabold text-xl sm:text-3xl tracking-widest uppercase mb-2" data-id="element-223">
            2N Intensiv Curriculum
          </h2>
          <p className="text-[#748282] font-semibold tracking-wider mb-6" data-id="element-224">
            78 FORTBILDUNGSPUNKTE
          </p>

          <p className="text-slate-300 font-medium text-sm sm:text-base leading-relaxed mb-6 max-w-lg mx-auto" data-id="element-225">
            Buchen Sie unsere gesamte Kursreihe A, B, C, D und profitieren Sie
            von einem <span className="text-white font-bold" data-id="element-226">Sonderpreis</span>{' '}
            und einem{' '}
            <span className="text-[#59d0d4] font-bold" data-id="element-227">
              kostenfreien Alignertherapie-Kurs
            </span>
            !
          </p>

          <div className="mb-6" data-id="element-228">
            <p className="text-[#59d0d4] text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight mb-3 drop-shadow-lg" data-id="element-229">
              2.760 € ERSPARNIS
            </p>
            <div className="flex items-center justify-center gap-4 text-lg sm:text-xl mb-2" data-id="element-230">
              <span className="text-[#748282] line-through decoration-2" data-id="element-231">
                8.250 €
              </span>
              <span className="text-white font-bold text-xl sm:text-2xl" data-id="element-232">
                5.490 €
              </span>
            </div>
            <p className="text-[#748282] text-xs sm:text-sm font-medium" data-id="element-233">
              zzgl. MwSt. · inkl. Verpflegung & Abendveranstaltung
            </p>
          </div>

          <Link to="/kontakt" onClick={() => setIsVisible(false)} className="inline-block bg-[#59d0d4] hover:bg-[#4abfc3] text-[#1a1a1a] font-extrabold uppercase tracking-wider px-10 sm:px-12 py-4 rounded-md transition-all hover:scale-105 hover:shadow-[0_0_20px_rgba(89,208,212,0.4)] mb-4" data-id="element-234">
            Jetzt buchen
          </Link>

          <p className="text-[#748282] text-xs font-medium" data-id="element-235">
            Im Buchungsformular „gesamte Kursserie" auswählen
          </p>
        </div>
      </div>
    </div>;
}